import { Tag } from '../types/graphql'

export const filterTagsByCategory = (tags: Tag[], category: string): Tag[] => {
  return tags.filter((tag: Tag) => tag.category!.identifier === category)
}

export const hasTagsFromCategory = (tags: Tag[], category: string): boolean => {
  return filterTagsByCategory(tags, category).length > 0
}
